module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-carousel-3d-slide u-absolute",
    class: [_vm.isCurrent ? 'c-carousel-3d-slide--current' : 'c-carousel-3d-slide--not-current']
  }, [_c('div', {
    staticClass: "c-carousel-3d-slide__middle u-absolute u-align-center",
    class: [_vm.hasVisual ? 'has-visual' : '']
  }, [(_vm.hasVisual) ? _c('div', {
    staticClass: "c-carousel-3d-slide__visual u-absolute js-autoplay-hover",
    class: [_vm.content.video ? 'has-video' : '']
  }, [_c('div', {
    staticClass: "c-carousel-3d-slide__opacity c-carousel-3d-slide__opacity--0 u-fit-h"
  }, [(_vm.content.video) ? _c('div', [_c('transition', [(_vm.isCurrent && _vm.content.video.type === 'youtube') ? _c('div', {
    staticClass: "c-carousel-3d-slide__youtube u-fit"
  }, [(_vm.content.video && _vm.content.video.type === 'youtube') ? _c('app-youtube', {
    staticClass: "u-block u-absolute u-fit u-pos-tl",
    attrs: {
      "id": _vm.content.video.id,
      "autoplay": true,
      "mute": true
    },
    on: {
      "ready": _vm._onYoutubeReady,
      "play": _vm._onYoutubePlay
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('transition', [(_vm.isCurrent && _vm.content.video.type === 'jwplayer') ? _c('div', {
    staticClass: "c-carousel-3d-slide__jwplayer u-fit"
  }, [_c('div', {
    staticClass: "js-jwplayer"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', [(_vm.content.image && !_vm.videoPlayedOnce) ? _c('div', {
    staticClass: "c-carousel-3d-slide__preview is-clickable u-block u-absolute u-pos-tl u-fit",
    style: (("background-image:url(" + (_vm.content.image) + ")")),
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onPreviewClick($event)
      }
    }
  }) : _vm._e()])], 1) : _c('div', [(_vm.content.image && !_vm.videoPlayedOnce) ? _c('div', {
    staticClass: "c-carousel-3d-slide__preview u-block u-absolute u-pos-tl u-fit",
    style: (("background-image:url(" + (_vm.content.image) + ")"))
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-carousel-3d-slide__overlay u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), (_vm.content.video) ? _c('div', {
    staticClass: "c-carousel-3d-slide__play-icon u-block u-absolute u-pos-tl u-fit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onVideoClick($event)
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-carousel-3d__texts c-carousel-3d-slide__opacity",
    class: [_vm.hasVisual ? 'has-visual' : '']
  }, [_c('div', {
    staticClass: "c-carousel-3d__texts-part js-autoplay-hover",
    class: [_vm.hasDescription ? 'has-description' : '', _vm.hasVisual ? 'has-visual' : '']
  }, [(_vm.content.title && _vm.content.button) ? _c('a', {
    staticClass: "c-carousel-3d-slide__title u-block u-relative u-uppercase u-bold u-marg-b-xs u-marg-b-xxs@xs u-color--white",
    class: [_vm.hasVisual ? 'has-visual' : '', _vm.hasDescription ? 'has-description' : ''],
    attrs: {
      "href": _vm.content.button.url,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : (_vm.content.title) ? _c('div', {
    staticClass: "c-carousel-3d-slide__title u-block u-uppercase u-bold u-marg-b-xs u-marg-b-xxs@xs",
    class: [_vm.hasVisual ? 'has-visual' : '', _vm.hasDescription ? 'has-description' : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.countdown_date) ? _c('app-counter', {
    staticClass: "c-carousel-3d-slide__counter u-relative c-counter--big-red u-marg-b-md u-marg-b-xs@xs",
    attrs: {
      "date": _vm.content.countdown_date
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.button && !_vm.hasDescription) ? _c('a', {
    staticClass: "c-carousel-3d__button u-color--white u-uppercase",
    attrs: {
      "href": _vm.content.button.url,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.button.label)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.hasDescription) ? _c('div', {
    staticClass: "c-carousel-3d__texts-part js-autoplay-hover",
    class: [_vm.hasDescription ? 'has-description' : '', _vm.hasVisual ? 'has-visual' : '']
  }, [(_vm.content.button) ? _c('a', {
    staticClass: "c-carousel-3d-slide__description u-block u-marg-b-xs u-marg-b-xxs@xs u-color--white",
    attrs: {
      "href": _vm.content.button.url,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.description)
    }
  }) : _c('div', {
    staticClass: "c-carousel-3d-slide__description u-marg-b-xs u-marg-b-xxs@xs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description)
    }
  }), _vm._v(" "), (_vm.content.button && _vm.hasDescription) ? _c('a', {
    staticClass: "c-carousel-3d__button u-color--white u-uppercase",
    attrs: {
      "href": _vm.content.button.url,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.button.label)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-carousel-3d-slide__click-blocker u-block u-absolute u-pos-tl u-fit",
    on: {
      "click": function($event) {
        _vm._onSlideClick($event)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11667353"}!./src/scripts/components/app-carousel-3d-slide/template.html
// module id = 884
// module chunks = 0